export enum MenuOptionUserGroup {
    SEE_DETAIL = 1,
    EDIT = 2,
    PERMISSIONS = 3,
    DELETE = 4
}